import { useEffect, useState } from "react";
import Filters from "./Filters";
import Table from "./Table";
import api from "../../../../config";
import { getClients, getProducts, objectToURLParams, showMessageError } from "../../../../classes/functions";

export default function Commitment(){
    const [filters, setFilters] = useState({
        produto: {
            label: "",
            value: ""
        },
        cliente: {
            label: "",
            value: ""
        }
    });
    const [searchListsToFilters, setSearchListsToFilters] = useState({
        produto: "",
        cliente: ""
    });
    const [carrying, setCarrying] = useState(false);
    const [products, setProducts] = useState([]);
    const [clients, setClients] = useState([]);
    const [commitments, setCommitments] = useState([]);

    function getCommitments(){
        api
        .get(`/api/relatorios/empenho?${objectToURLParams(filters)}`)
        .then((response) => {
            setCommitments(response?.data?.result);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        })
    }

    useEffect(() => {
        getCommitments();
    }, []);

    useEffect(() => {
        getProducts(searchListsToFilters.produto, setProducts, setCarrying);
    }, [searchListsToFilters.produto]);

    useEffect(() => {
        getClients(searchListsToFilters.cliente, setClients, setCarrying);
    }, [searchListsToFilters.cliente]);

    return (
        <>
            <Filters filters={{state: filters, setState: setFilters}} options={{produto: products, cliente: clients}} getCommitments={getCommitments} searchListsToFilters={{state: searchListsToFilters, setState: setSearchListsToFilters}} />
            <br />
            <Table commitments={commitments} />
        </>
    )
}